import { render, staticRenderFns } from "./SaleSuccess.vue?vue&type=template&id=4ffd0e41&"
import script from "./SaleSuccess.vue?vue&type=script&lang=js&"
export * from "./SaleSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports